import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import "@firebase/messaging";
// import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { RequestBodyService } from "src/app/services/request-body.service";
import { Orientation, allOrientations } from "../app.constants";

@Injectable({
  providedIn: "root",
})
export class OrientationService {
  constructor(public requestBodyService: RequestBodyService, @Inject(DOCUMENT) private document: Document) {}

  lockOrientation(orientation: Orientation) {
    try {
      if (allOrientations.includes(orientation)) {
        return window.screen.orientation["lock"](orientation).catch((error) => {
          return error;
        });
      }
    } catch (error) {
      return error;
    }
  }

  getOrientation() {
    // return this.orientation.type.toUpperCase().indexOf("PORTRAIT") > -1 ? "PORTRAIT" : "LANDSCAPE";
    try {
      if (window.screen && window.screen.orientation) {
        return window.screen.orientation.type;
      }
    } catch (error) {
      return error;
    }
  }

  public enterFullscreen(): void {
    try {
      const elem = this.document.documentElement;
      if (elem.requestFullscreen) {
        elem
          .requestFullscreen()
          .then(() => {
            // console.info('entered fullscreen');
          })
          .catch((error) => {
            return error;
          });
      } else if (elem["webkitRequestFullscreen"]) {
        elem["webkitRequestFullscreen"]();
      } else if (elem["mozRequestFullScreen"]) {
        elem["mozRequestFullScreen"]();
      } else if (elem["msRequestFullscreen"]) {
        elem["msRequestFullscreen"]();
      }
    } catch (error) {
      return error;
    }
  }

  public isFullscreen(): boolean {
    // Check if the Fullscreen API is supported by the browser
    if (this.document.fullscreenEnabled || this.document["webkitFullscreenEnabled"]) {
      // Check if the this.document is currently in fullscreen mode
      return !!(this.document.fullscreenElement || this.document["webkitFullscreenElement"]);
    } else {
      return false;
    }
  }
}
